/**
 * 将全大写蛇形（如 'HELLO_WORLD'）转换为普通字母加空格（如 'Hello world'）
 * @param {string} str
 * @returns {string}
 */
const specialSnakeCases = {
  WHATS_APP: "WhatsApp",
  WHATS_APP_GROUP: "WhatsApp Group",
};

export function snakeToNormal(str) {
  if (!str) return "";
  const raw = String(str);
  const upper = raw.toUpperCase();
  if (specialSnakeCases[upper]) {
    return specialSnakeCases[upper];
  }
  const words = raw.toLowerCase().split("_");
  if (words.length === 0) return "";
  return words
    .map((word, idx) =>
      idx === 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word
    )
    .join(" ");
}

/**
 * 注册为 String.prototype.capitalize 静态扩展方法
 */
if (!String.prototype.capitalize) {
  String.prototype.capitalize = function() {
    if (!this) return "";
    return this.charAt(0).toUpperCase() + this.slice(1);
  };
}

export function capitalize(str) {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
}
